import React from 'react';

export interface WidgetRegistryEntry {
  label: string;
  category: 'summary' | 'chart' | 'kpi';
  component: React.LazyExoticComponent<React.FC<any>> | React.FC<any>;
}

// Widget registry maps string keys to component metadata
export const widgetRegistry: Record<string, WidgetRegistryEntry> = {
  'kpi-cards': {
    label: 'Market KPI Cards',
    category: 'kpi',
    component: React.lazy(() => import('./widgets/KpiCardsWidget')),
  },
  'pe-fair-price': {
    label: 'PE Fair Resin Price',
    category: 'chart',
    component: React.lazy(() =>
      import('./widgets/FairPriceWidget').then((m) => ({
        default: () => React.createElement(m.default, { polymer: 'PE' }),
      }))
    ),
  },
  'pp-fair-price': {
    label: 'PP Fair Resin Price',
    category: 'chart',
    component: React.lazy(() =>
      import('./widgets/FairPriceWidget').then((m) => ({
        default: () => React.createElement(m.default, { polymer: 'PP' }),
      }))
    ),
  },
  'ps-fair-price': {
    label: 'PS Fair Resin Price',
    category: 'chart',
    component: React.lazy(() =>
      import('./widgets/FairPriceWidget').then((m) => ({
        default: () => React.createElement(m.default, { polymer: 'PS' }),
      }))
    ),
  },
  'pvc-fair-price': {
    label: 'PVC Fair Resin Price',
    category: 'chart',
    component: React.lazy(() =>
      import('./widgets/FairPriceWidget').then((m) => ({
        default: () => React.createElement(m.default, { polymer: 'PVC' }),
      }))
    ),
  },
  'pet-fair-price': {
    label: 'PET Fair Resin Price',
    category: 'chart',
    component: React.lazy(() =>
      import('./widgets/FairPriceWidget').then((m) => ({
        default: () => React.createElement(m.default, { polymer: 'PET' }),
      }))
    ),
  },
  'feedstock-daily': {
    label: 'Feedstock Running Daily',
    category: 'chart',
    component: React.lazy(() => import('./widgets/FeedstockDailyWidget')),
  },
  'petchem-averages': {
    label: 'PetChem Averages',
    category: 'chart',
    component: React.lazy(() => import('./widgets/PetchemAveragesWidget')),
  },
};

export const widgetsByCategory = (category?: string) =>
  Object.entries(widgetRegistry).filter(
    ([, entry]) => !category || entry.category === category
  );
